import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophoneSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_5988)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1991 5.23335C11.1991 3.76691 10.0103 2.57812 8.54389 2.57812C7.07746 2.57812 5.88867 3.76691 5.88867 5.23335V9.4817C5.88867 10.9481 7.07746 12.1369 8.54389 12.1369C10.0103 12.1369 11.1991 10.9481 11.1991 9.4817V5.23335Z",
				stroke: "black",
				strokeWidth: 1.06209,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54346 14.2617V16.3859",
				stroke: "black",
				strokeWidth: 1.06209,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2962 10.0117C13.1584 11.1755 12.5985 12.2483 11.7225 13.0267C10.8464 13.8051 9.71527 14.2351 8.54337 14.2351C7.37147 14.2351 6.2403 13.8051 5.36429 13.0267C4.48827 12.2483 3.9283 11.1755 3.79053 10.0117",
				stroke: "black",
				strokeWidth: 1.06209,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_5988",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.9934,
			height: 16.9934,
			fill: "white",
			transform: "translate(0.046875 0.984375)"
		})
	}) })]
});
export default SvgMicrophoneSymbol;
